import { useLocation } from 'react-router';
import classNames from 'classnames';
import moment from 'moment';

import { pendingOrdersDatePlacedFormat } from '../../../../lib/constants/date-time.constants';
import lang from '../../../../lib/language';
import { SORExtendedHoursMarker } from '../../../../lib/models/gateway/types';
import { getEndOfDayOrderExpirationDate } from '../../../../lib/store/reporting/trading/order-helpers';
import { TimeInForce } from '../../../../lib/store/reporting/types';

import { UI_ROUTES } from '../../../../util/routes';

import styles from './styles.module.scss';

type Props = {
  expirationDate: string;
  expirationDateStyle: string | undefined;
  timeInForce: number;
  externalHours: SORExtendedHoursMarker;
  externalHoursStyle: string | undefined;
  sorExecutedQuantity: number;
  totalQuantity: number;
  isMobile?: boolean;
}

const PendingOrdersExpirationDate = ({
  expirationDate,
  timeInForce,
  externalHours,
  externalHoursStyle,
  expirationDateStyle,
  sorExecutedQuantity,
  totalQuantity,
  isMobile,
}: Props) => {
  const location = useLocation();
  const locationPath = location.pathname;
  const isSymbolPath = locationPath.includes(UI_ROUTES.symbol);

  return (
    <>
      <div className={classNames([styles.expirationWrapper, { [styles.symbolStylesContainer]: isSymbolPath }])}>
        {(timeInForce === TimeInForce.GTC || timeInForce === TimeInForce.GoodTillDate)
          && (
            <div className={expirationDateStyle}>
              {moment.utc(expirationDate).format(pendingOrdersDatePlacedFormat)}
            </div>
          )}
        {(timeInForce === TimeInForce.Day || timeInForce === TimeInForce.ExtendedDay)
          && <div className={expirationDateStyle}>{getEndOfDayOrderExpirationDate()}</div>}
      </div>
      {externalHours === 'X' && (
        <div
          className={classNames(
            [styles.externalHoursContainer, { [styles.symbolStyles]: isSymbolPath && !isMobile }],
          )}
        >
          {isMobile && sorExecutedQuantity && sorExecutedQuantity < totalQuantity && (
            <div className={styles.partialFill}>
              <p>{`${sorExecutedQuantity} / ${totalQuantity}`}</p>
              <p>•</p>
              <p>{lang.commonMyAccountPendingOrdersPartiallFill()}</p>
            </div>
          )}
          <div
            className={classNames([externalHoursStyle, { [styles.symbolExternalHours]: isSymbolPath && !isMobile }])}
          >
            {!isMobile && '•'}
            {' '}
            {lang.commonMyAccountPendingOrdersExtHours()}
          </div>
        </div>
      )}
    </>
  );
};

export default PendingOrdersExpirationDate;
